import React from 'react';
import { View, StyleSheet } from '@react-pdf/renderer';
import InvoiceTitle from './InvoiceTitle';
import InvoiceCompany from './InvoiceCompany';

const styles = StyleSheet.create({
  headerContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 10,
  }
});


const InvoiceHeader = ({ invoice, retailerInfo }) => {
  const orderNumber = invoice.sequential_number ? `${invoice.sequential_number}` : invoice.order_id;

  return (
    <View style={[styles.headerContainer, { marginTop: retailerInfo.logo_url ? 10 : 24 }]}>
      <InvoiceTitle title={`Orden # ${orderNumber}`} />
      <InvoiceCompany retailerInfo={retailerInfo} />
    </View>
  );
}

export default InvoiceHeader;